import type { WorkboardEmailTemplate } from 'api/models/WorkboardEmailTemplate';
import { WorkboardEmailTemplate as WorkboardEmailTemplateEnum } from 'api/models/WorkboardEmailTemplate';
import type { WorkboardEmailTemplateListResponse } from 'api/models/WorkboardEmailTemplateListResponse';
import { ApiService } from 'api/services/ApiService';

export type WorkboardEmailTemplateKind = WorkboardEmailTemplateEnum.kind;

export const listWorkboardEmailTemplates = (
  kind: WorkboardEmailTemplateKind
): Promise<WorkboardEmailTemplateListResponse> =>
  ApiService.apiDashboardWorkboardEmailTemplatesList(kind);

export const createWorkboardEmailTemplate = (
  kind: WorkboardEmailTemplateKind,
  data: Pick<WorkboardEmailTemplate, 'name' | 'email_subject' | 'introduction'>
): Promise<WorkboardEmailTemplate> =>
  ApiService.apiDashboardWorkboardEmailTemplatesCreate(data, kind);

export const updateWorkboardEmailTemplate = (
  id: string,
  data: Partial<Pick<WorkboardEmailTemplate, 'name' | 'email_subject' | 'introduction'>>
): Promise<WorkboardEmailTemplate> =>
  ApiService.apiDashboardWorkboardEmailTemplatesPartialUpdate(id, data as WorkboardEmailTemplate);

export const deleteWorkboardEmailTemplate = (id: string): Promise<void> =>
  ApiService.apiDashboardWorkboardEmailTemplatesDelete(id);

export const ONBOARDING_EMAIL_TEMPLATE_KIND = WorkboardEmailTemplateEnum.kind.ONBOARDING;
export const FINAL_REPORT_EMAIL_TEMPLATE_KIND = WorkboardEmailTemplateEnum.kind.FINAL_REPORT;
